import React from "react";
import { FilloutStandardEmbed } from "@fillout/react";
import "@fillout/react/style.css";

function Contact() {
  return (
    <div
      className="max-w-[1200px] mx-auto ☐ bg-black sm:py-20 p-5"
      id="contact"
    >
      <div className="text-center">
        <h2 className="text-4x1 font-bold leading-tight primary-color">
          Contact Me
        </h2>
      </div>
      <div className="max-w-[800px] mx-auto">
        I
        <div
          className="mt-6 ☐ bg-[#161616] rounded-x1"
          style={{
            height: 430,
            // width: 300,
          }}
        >
          <FilloutStandardEmbed filloutId="5Bh2qF34vqus" />
        </div>
      </div>
    </div>
  );
}

export default Contact;
